var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoqallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.7 27.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2,23.4c0,.5,0,1,0,1.5,0,.6,0,1.3,0,1.9,0,.2,0,.3-.2,.3-1.6,0-2.4,0-4.1,0v-3.6c-.9-.3-2.2-.5-3-.8-4-1.6-6.5-4.6-7.2-8.9-.6-4,.4-7.5,3.3-10.4,1.8-1.7,3.9-2.7,6.3-3.1,2.9-.5,5.7-.3,8.4,1,3.8,1.8,6.1,4.8,6.6,9,.5,3.9-.7,7.3-3.6,10-1.7,1.6-4.1,2.6-6.5,3,0,0,0,0-.1,0Zm-.2-4.6c0,0,.6-.1,.6-.1,0,0,.1,0,.2,0,1.6-.6,2.8-1.6,3.5-3.2,.7-1.4,.9-3,.8-4.5-.2-2-1.1-3.8-2.7-5-1.5-1.1-3.2-1.5-5.1-1.3-2.7,.3-4.6,1.6-5.7,4.1-.6,1.3-.7,2.7-.6,4.1,.2,2,1,3.7,2.6,4.9,.6,.5,1.6,.8,2.4,1v-4.9h4.1c0,1.6,0,3.4,0,5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20.8c-3.5,9.1-6.9,18.1-10.4,27.1C6.9,18,3.5,9,0,0ZM14.3,4.4H6.5c1.3,3.6,2.6,7.1,3.9,10.7,1.3-3.6,2.6-7.2,3.9-10.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4,27c-.8,0-1.5,0-2.3,0-.7,0-1.5,0-2.2,0-.2,0-.3,0-.4-.3-.3-.8-.6-1.5-.9-2.3-.1-.3-.3-.4-.6-.4-2.7,0-5.4,0-8.1,0-.4,0-.5,.2-.7,.5-.3,.8-.6,1.6-.9,2.4,0,0-.1,.2-.2,.2-1.5,0-3,0-4.5,0,0,0,0,0,0,0,3.4-8.9,6.9-17.8,10.3-26.7,3.5,8.9,7,17.8,10.4,26.8Zm-10.4-15.6c-1,2.9-2,5.8-3,8.7h6.1c-1-2.9-2-5.8-3.1-8.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42,11.5c0,1.4-1,3.7-2.9,5.6-1.9,1.9-4.2,2.8-6.8,2.9-2.7,0-5-1-6.9-2.9-1.8-1.9-2.8-4.2-2.8-6.8,0-2.8,1.1-5.2,3.2-7.1,2-1.8,4.4-2.7,7-2.5,4.8,.3,9.1,4.2,9.1,10.9Zm-9.7,4c3,0,5.3-2.4,5.3-5.2,0-3-2.2-5.3-5.3-5.3-3.2,0-5.2,2.4-5.2,5.3,0,2.9,2.3,5.2,5.2,5.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.1,22.5h.5c2.9,0,5.8,0,8.7,0,.5,0,.4,0,.4,.4,0,1.2,0,2.4,0,3.6,0,.5,0,.5-.4,.5-4.4,0-8.8,0-13.2,0-.3,0-.4,0-.4-.4,0-8.4,0-16.8,0-25.1,0-.3,.1-.4,.4-.4,1.2,0,2.4,0,3.6,0,.4,0,.4,0,.4,.4,0,6.9,0,13.7,0,20.6s0,.3,0,.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2,26.9v-.4c0-8.4,0-16.8,0-25.1,0-.3,0-.5,.4-.5,1.2,0,2.4,0,3.6,0,.3,0,.4,0,.4,.4,0,6.9,0,13.8,0,20.6s0,.3,0,.5h.4c2.9,0,5.7,0,8.6,0,.4,0,.5,0,.5,.5,0,1.2,0,2.4,0,3.6,0,.3,0,.4-.3,.4-4.5,0-9,0-13.5,0,0,0-.1,0-.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.7,22.6h17.2c0,0,0,.2,0,.3,0,1.3,0,2.5,0,3.8,0,.2,0,.3-.3,.3-5.6,0-11.2,0-16.8,0,0,0,0,0,0,0v-4.3Z",
    style: {
      fill: "#e91d25"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.7,
    y: 22.6,
    width: 17.3,
    height: 4.4,
    style: {
      fill: "#e91d25"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3,
    y: 18.2,
    width: 13.6,
    height: 4.4,
    transform: "translate(38.6 79.5) rotate(-90)",
    style: {
      fill: "#e91d25"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoqallLogo);
export default __webpack_public_path__ + "static/media/voqall_logo.adf18b3607f2c260a41873ce9fd4af4f.svg";
export { ForwardRef as ReactComponent };